<template>
    <v-dialog width="550" v-model="mostrarModalImportar" persistent>
        <template slot="activator">
            <az-call-to-action active css-class="ma-0" class="text-uppercase">
                <v-icon>upload</v-icon>
                Importar
            </az-call-to-action>
        </template>

        <v-card v-if="ehModoImportacaoArquivo">
          <v-card-title class="primary modal-title" primary-title>
            <span>Importar processo por arquivo</span>
            <v-btn flat depressed @click="fecharModalImportar">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap white>
                <v-flex md12 sm12 xs12>
                  <edl-file-upload v-if="!arquivoImportar" height="120px" ref="azFileUploadImportar"
                                   :accept="'application/json'"
                                   url-personalizada-upload="api/v1/importar-processo-arquivo"
                                   :repository="'repo1:licitacao'"
                                   @uploadCompleto="importacaoConcluida">
                    <a @click.prevent="$refs.azFileUploadImportar.openFileSelector()">
                      <v-icon>archive</v-icon>
                      Enviar Arquivo
                    </a>
                    <p>Arraste e solte o arquivo aqui para ser carregado.</p>
                  </edl-file-upload>
                  <div v-else style="color: #777; text-align: center">
                    <div class="pb-2">
                      O seguinte arquivo será utilizado para a importação:
                    </div>
                    <span class="px-2 py-2" style="background-color: #d3d3d3; border-radius: 10px">
                      <v-icon class="pl-0 ml-0" color="#777">description</v-icon>
                      {{arquivoImportar.nome}}
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-title class="primary modal-title" primary-title>
                <span>Importar dados do processo</span>
                <v-btn flat depressed @click="fecharModalImportar">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap white>
                        <v-flex sm9 xs12>
                            <v-combobox
                                v-model="processo"
                                :items="numerosProcessosValidos" placeholder="Ex. 000.000.123/2019"
                                :name="'Numero do Processo'" label="Número do Processo"
                                :key="'Numero do Processo'"
                                :error-messages="errors.collect('Numero do Processo')"
                                :item-text="formataNumeroComSigla"
                                :search-input.sync="buscarAutocomplete"
                                ref="processoAutocomplete"
                                id="processoAutocomplete"
                                required
                                :loading="loading"
                                return-object
                            />
                        </v-flex>
                        <v-flex sm3 xs12 class="text-xs-center">
                            <az-call-to-action @click="importarNumeroProcesso" slot="actions">
                                Importar
                            </az-call-to-action>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import EdlFileUpload from "@/commons/components/file/EdlFileUpload";
import {mapState} from "vuex";

export default {
    name: 'ImportarProcesso',
    components: {EdlFileUpload},
    inject: ['$validator'],
    data() {
        return {
            mostrarModalImportar: false,
            processo: null,
            numerosProcessosValidos: [],
            buscarAutocomplete: null,
            loading: false,
            arquivoImportar: null
        }
    },
    computed:{
      ...mapState(['parametros']),
      ehModoImportacaoArquivo(){
        return this.parametros.propriedadesLicitacao.integration.sistemaDeGestao === 'file-system'
      }
    },
    methods: {
        async importarNumeroProcesso() {
            await this.errors.clear()
            const error = {
              field: 'Numero do Processo',
              msg: 'Erro ao importar processo!',
            };

            if(this.numerosProcessosValidos.length === 1){
              this.processo = this.numerosProcessosValidos[0]
            }

            if(this.numerosProcessosValidos.length > 1){
              error.msg = 'Selecione um processo!'
              await this.errors.add(error)
              return
            }

            if(!this.buscarAutocomplete){
              error.msg = 'Insira o número do processo!'
              await this.errors.add(error)
              return
            }

            if(this.buscarAutocomplete.length < 2){
              error.msg = 'Número inválido!'
              this.errors.add(error)
              return
            }

            const processoEhString = typeof this.processo === 'string' || this.processo instanceof String
            const processoEhNull = this.processo === null
            if(this.numerosProcessosValidos.length === 0 && (processoEhString || processoEhNull)){
              error.msg = 'Nenhum processo encontrado!'
              this.errors.add(error)
              return
            }

            alert("Documentos que não sejam .pdf inseridos na fase do Edital serão importados, porém, não serão virtualizados")
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Importando o número do processo...')
            const resposta = await this.$store.dispatch(actionTypes.IMPORTAR_PROCESSO, this.processo)
            this.fecharModalImportar()
            this.mostrarNotificacaoSucesso('Número de processo importado com sucesso.')
            this.irParaEdicaoLicitacao(resposta.id, resposta.modalidade)
        },
        irParaEdicaoLicitacao(id, modalidade) {
          this.$router.push({

            name: modalidade === 'CREDENCIAMENTO' ? 'credenciamento' : 'licitacao',
            params: {id},
            query: {edicao: true}
          })
        },
        fecharModalImportar() {
            this.limparCampoModal()
            this.arquivoImportar = null
            this.mostrarModalImportar = false
        },
        limparCampoModal() {
            this.processo = null
        },
        focusInput() {
            this.$refs.processoAutocomplete.focus()
        },
        formataNumeroComSigla(item) {
            return `${item.processo} - ${item.orgao}`
        },
        importacaoConcluida() {
            const respostaApi = this.$refs['azFileUploadImportar'].retornosApiPersonalizada[0]
            this.fecharModalImportar()
            this.mostrarNotificacaoSucesso('Processo importado com sucesso.')
            this.irParaEdicaoLicitacao(respostaApi.id)
            this.resetUploadedFiles()
        },
        isUploadArquivosTemporariosCompleto() {
            return !this.isUploadEmAndamento() && this.loki.uploadedFiles.length > 0
        },
        isUploadEmAndamento() {
            const arquivosEmProgresso = this.loki.uploadFileProgress
            const numeroArquivosEmProgresso = Object.keys(arquivosEmProgresso).length
            if (!numeroArquivosEmProgresso) {
                return false
            }
            let isEmAndamento = false
            Object.keys(arquivosEmProgresso).forEach(chaveArquivo => {
                const arquivo = arquivosEmProgresso[chaveArquivo]
                if (!arquivo.error) {
                    isEmAndamento = true
                }
            })
            return isEmAndamento
        },
    },
    watch: {
        async buscarAutocomplete(processo) {
          try {
              if (processo && processo.trim().length > 1) {
                this.desabilitarLoadingGlobal()
                this.loading = true;
                await this.$store.dispatch(actionTypes.BUSCAR_PROCESSOS_DISPONIVEIS, processo)
                this.numerosProcessosValidos = this.$store.state.processosAutocomplete
                    .map(proc => ({ processo: proc.numero, orgao: proc.siglaOrgao }))
                this.focusInput()
                this.loading = false;
              }
          }catch(erro){
            setTimeout(() => this.loading = false, 1000)
            this.focusInput()
            throw new Error(erro)
          }
        },
        mostrarModalImportar: {
            handler(novoValor){
              if(novoValor === true){
                setTimeout(() => {
                  if(!this.ehModoImportacaoArquivo){
                    this.focusInput()
                  }
                }, 300)
              }
            }
        },
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        span
            width 90%

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-menor
        color #fff
        border-radius 2px
        padding 5px 10px
        box-sizing border-box

        &:hover, &:focus, &:active
            background-color var(--v-secondary-lighten1) !important

    @media (max-width 500px)
        .modal-title span
            width 80%
</style>
